import { CheckStatusEnum } from "./product-api-status.definitions";

export class ClearProductsError
{
    static readonly type = '[ProductApiStatus] Clear Products Error';
}

export class ClearProductError
{
    static readonly type = '[ProductApiStatus] Clear Product Error';
}

export class ProductsError
{
    static readonly type = '[ProductApiStatus] Products Error';

    constructor(public error: string | null) { }
}

export class ProductError
{
    static readonly type = '[ProductApiStatus] Product Error';

    constructor(public error: string | null) { }
}

export class VersionsError
{
    static readonly type = '[ProductApiStatus] Versions Error';

    constructor(public error: string | null) { }
}

export class NotesError
{
    static readonly type = '[ProductApiStatus] Notes Error';

    constructor(public error: string | null) { }
}


export class ClearVersionsError
{
    static readonly type = '[ProductApiStatus] Clear Versions Error';
}

export class ClearNotesError
{
    static readonly type = '[ProductApiStatus] Clear Note Error';
}

export class ClearSendMail
{
    static readonly type = '[ProductApiStatus] Clear Send Mail';
}

export class CreateVersionError
{
    static readonly type = '[ProductApiStatus] Create Version Error';

    constructor(public error: string | null)
    {
    }
}

export class CreateSubscriptionError
{
    static readonly type = '[ProductApiStatus] Create Subscription Error';

    constructor(public error: string | null) { }
}

export class ClearCreateSubscriptionError
{
    static readonly type = '[ProductApiStatus] Clear Create Subscription Error';
}

export class CreateUnsubscribeError
{
    static readonly type = '[ProductApiStatus] Create Unsubscribe Error';

    constructor(public error: string | null) { }
}

export class ImportedTranslation
{
    static readonly type = '[ProductApiStatus] Imported Translation';

    constructor(public value: boolean) { }
}

export class ClearImportedTranslation
{
    static readonly type = '[ProductApiStatus] Clear Imported Translation';
}

export class ClearCreateUnsubscribeError
{
    static readonly type = '[ProductApiStatus] Clear Create Unsubscribe Error';

}

export class ClearCreateVersionError
{
    static readonly type = '[ProductApiStatus] Clear Create Version Error';
}


export class CreateProductError
{
    static readonly type = '[ProductApiStatus] Create Product Error';

    constructor(public error: string | null) { }
}

export class ClearCreateProductError
{
    static readonly type = '[ProductApiStatus] Clear Create Product Error';
}

export class CreateNoteError
{
    static readonly type = '[ProductApiStatus] Create Note Error';

    constructor(public error: string | null) { }
}

export class ClearCreateNoteError
{
    static readonly type = '[ProductApiStatus] Clear Create Note Error';
}

export class CreateTagError
{
    static readonly type = '[ProductApiStatus] Create Tag Error';

    constructor(public error: string | null) { }
}

export class ClearCreateTagError
{
    static readonly type = '[ProductApiStatus] Clear Create Tag Error';
}

export class ProductDeleted
{
    static readonly type = '[ProductApiStatus] Product Deleted';

    constructor(public value: boolean)
    {
    }
}

export class ClearProductDeleted
{
    static readonly type = '[ProductApiStatus] Clear Product Deleted';
}

export class VersionDeleted
{
    static readonly type = '[ProductApiStatus] Version Deleted';

    constructor(public value: boolean) { }
}

export class InitialVersionsLoaded
{
    static readonly type = '[ProductApiStatus] Initial Versions Loaded';

    constructor(public value: boolean) { }
}

export class ClearVersionDeleted
{
    static readonly type = '[ProductApiStatus] Clear Version Deleted';
}

export class NoteDeleted
{
    static readonly type = '[ProductApiStatus] Note Deleted';

    constructor(public value: boolean) { }
}

export class ClearNoteDeleted
{
    static readonly type = '[ProductApiStatus] Clear Note Deleted';
}

export class CheckedVersionAvailable
{
    static readonly type = '[ProductApiStatus] Checked Version Available';
}

export class ClearCheckVersion
{
    static readonly type = '[ProductApiStatus] Clear Check Version';
}

export class CheckedNoteAvailable
{
    static readonly type = '[ProductApiStatus] Checked Note Available';
}

export class ClearCheckNote
{
    static readonly type = '[ProductApiStatus] Clear Check Note';
}


export class SetEdited
{
    static readonly type = '[ProductApiStatus] Set Edited';

    constructor(public value: boolean) { }
}

export class SetProductChanged
{
    static readonly type = '[ProductApiStatus] Set Product Changed';

    constructor(public value: boolean) { }
}

export class SetExported
{
    static readonly type = '[ProductApiStatus] Set Exported';

    constructor(public value: boolean) { }
}


export class SetCreatedProduct
{
    static readonly type = '[ProductApiStatus] Set Created Product';

    constructor(public value: boolean) { }
}

export class SetCreatedVersion
{
    static readonly type = '[ProductApiStatus] Set Created Version';

    constructor(public value: boolean) { }
}

export class SetCreatedNote
{
    static readonly type = '[ProductApiStatus] Set Created Note';

    constructor(public value: boolean) { }
}

export class SetCreatedTag
{
    static readonly type = '[ProductApiStatus] Set Created Tag';

    constructor(public value: boolean) { }
}

export class SetCreatedSubscription
{
    static readonly type = '[ProductApiStatus] Set Created Subscription';

    constructor(public value: boolean) { }
}

export class SetUnsubscribed
{
    static readonly type = '[ProductApiStatus] Set Unsubscribed';

    constructor(public value: boolean) { }
}

export class SetRemovedSubscription
{
    static readonly type = '[ProductApiStatus] Set Removed Subscription';

    constructor(public value: boolean) { }
}

export class SetSendMail
{
    static readonly type = '[ProductApiStatus] Set Send Mail';

    constructor(public value: boolean) { }
}

export class SetCheckVersion
{
    static readonly type = '[ProductApiStatus] Set Check Version';

    constructor(public value: CheckStatusEnum) { }
}

export class SetCheckNote
{
    static readonly type = '[ProductApiStatus] Set Check Note';

    constructor(public value: CheckStatusEnum) { }
}

export class ClearEdited
{
    static readonly type = '[ProductApiStatus] Clear Edited';
}

export class ClearExported
{
    static readonly type = '[ProductApiStatus] Clear Exported';
}

export class ClearCreatedProduct
{
    static readonly type = '[ProductApiStatus] Clear Created Product';
}

export class ClearCreatedVersion
{
    static readonly type = '[ProductApiStatus] Clear Created Version';
}

export class ClearCreatedNote
{
    static readonly type = '[ProductApiStatus] Clear Created Note';
}

export class ClearCreatedSubscription
{
    static readonly type = '[ProductApiStatus] Clear Created Subscription';
}

export class ClearUnsubscribed
{
    static readonly type = '[ProductApiStatus] Clear Unsubscribed';
}

export class ClearRemovedSubscription
{
    static readonly type = '[ProductApiStatus] Clear Removed Subscription';
}




